import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  padding: 16px 24px 24px;
  flex-direction: column;
  display: flex;
  height: 100%;
`;
export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: -8px;
`;
export const Left = styled.img`
  cursor: pointer;
`;
interface IItem {
  active: boolean;
}
export const Bottom = styled.div`
  display: flex;
  justify-self: flex-end;
  align-items: center;
  justify-content: flex-end;
  align-self: flex-end;
`;
export const Title = styled.p`
  color: ${beam.font.primary};
  flex: 1;
  margin-bottom: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
`;
export const Text = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height */
`;
export const Head = styled.p`
  display: flex;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  margin: 0;
  align-content: flex-start;
  align-items: flex-start;
  color: #1a1b1c;
  margin-bottom: 20px;
`;

export const Close = styled.button`
  cursor: pointer;
  font-size: 14px;
  margin-right: 20px;
  border: none;
  background: transparent;
`;
export const Name = styled.input`
  border: 1px solid ${beam.background.card};
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;
  width: 100%;
  color: ${beam.placeholder.primary};
  min-height: 32px;
  display: flex;
  padding-left: 14px;
  flex: 1;
  padding-right: 14px;
  -webkit-appearance: none;
  margin-bottom: 16px;

  ::placeholder {
    color: ${beam.placeholder.primary};
  }
`;
export const Description = styled.textarea`
  min-height: 100px;
  border: 1px solid ${beam.background.card};
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;
  width: 100%;
  color: ${beam.placeholder.primary};
  display: flex;
  flex: 1;
  padding-top: 8px;
  padding-left: 14px;
  padding-right: 14px;
  -webkit-appearance: none;
  margin-bottom: 16px;
`;

export const BottomText = styled.button`
  color: ${beam.color.primaryBlue};
  font-size: 14px;
  border: none;
  background: transparent;
  :disabled {
    opacity: 0.3;
    cursor: auto;
  }
`;

export const Block = styled.div`
  background: #fff;
  padding: 12px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  bottom: -200px;
  min-width: 200px;
  min-height: 200px;
  z-index: 11;
`;
export const Item = styled.div<IItem>`
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background: ${({ active }) => (active ? '#F6F8FF' : '#fff')};
  cursor: pointer;
`;
export const ItemList = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;

  & + & {
    margin-top: 16px;
  }
`;

interface IItemListText {
  active: boolean;
}

export const ItemListText = styled.div<IItemListText>`
  font-size: 14px;
  flex: 1;
  color: ${({ active }) => (active ? '#1371FE' : '#1a1b1c')};
`;

export const ItemText = styled.div`
  color: #1a1b1c;
  font-size: 16px;
  flex: 1;
`;
export const TitleTwo = styled(Title)`
  margin-bottom: 0;
  font-size: 12px;
  line-height: 18px;
  margin-left: -10px;
`;
